import React, { useEffect, useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, CheckCircleIcon } from 'lucide-react';
const newReviews = [{
  name: 'María Fernanda López',
  title: '¡Mi primera colección en 2 semanas!',
  review: 'Nunca había horneado en mi vida y en 2 semanas ya tenía mi primera colección lista para vender. El sistema es increíblemente claro.',
  img: 'https://cdn.magicpatterns.com/uploads/g5bqQeueFMQAEaxKLhQsJA/MKI_-_VAc29kF8UkcNwR3z_(1)_(1).jpg'
}, {
  name: 'Carolina Martínez',
  title: 'De $8 a $25 por unidad',
  review: 'Pasé de vender rolls a $8 a cobrar $25 por unidad. La diferencia es la presentación y el método. Mis clientas no pueden creer que los hago desde casa.',
  img: 'https://cdn.magicpatterns.com/uploads/bUB4cZnLDFsGxbc5ShYDFU/ChatGPT_Image_27_mar_2026,_07_06_07_p.m..jpg'
}, {
  name: 'Valentina Rojas',
  title: 'Tengo lista de espera',
  review: 'El pilar de menú rotativo cambió todo. Ahora mis clientas esperan cada nueva edición. Tengo lista de espera antes de publicar.',
  img: 'https://cdn.magicpatterns.com/uploads/4BxectLReGxzPBKQVEHbMd/t8MqdIdsf2MlGqgoBhTE9.png'
}, {
  name: 'Andrea Gutiérrez',
  title: 'Acabado de vitrina profesional',
  review: 'Yo ya sabía hornear, pero mis rolls se veían caseros. Con el método logré ese acabado de vitrina que siempre quise. Ahora me piden para eventos.',
  img: 'https://cdn.magicpatterns.com/uploads/tvdoerwiSGfZfwokaxCWgv/586097645_1402690924549963_4725454285749379982_n.jpg'
}];
export function TransformationSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  // Auto-rotate every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % newReviews.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  // Calculate visible slides for desktop (show 3 at a time)
  const getVisibleSlides = () => {
    const slides = [];
    for (let i = 0; i < 3; i++) {
      slides.push(newReviews[(currentIndex + i) % newReviews.length]);
    }
    return slides;
  };
  return <>
      {/* CREADO POR EMELY — Compact */}
      <section className="py-12 md:py-20 px-4" style={{
      backgroundColor: '#e76f51'
    }} data-id="element-352">
        <div className="max-w-4xl mx-auto" data-id="element-353">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.6
        }} className="flex flex-col md:flex-row items-center gap-6 md:gap-10" data-id="element-354">
            {/* Photo */}
            <img src="https://cdn.magicpatterns.com/uploads/qeMZYoKqudh3T57shFtBe5/Diseno_sin_titulo_(5)_(1).png" alt="Emely — Pastry Chef creadora del Método XL Iconic" loading="lazy" decoding="async" className="w-32 h-32 md:w-40 md:h-40 rounded-full object-cover flex-shrink-0 shadow-lg border-4 border-white/30" data-id="element-355" />

            {/* Info */}
            <div className="text-center md:text-left" data-id="element-356">
              <span className="text-xs font-bold tracking-[0.2em] uppercase mb-2 inline-block" style={{
              color: '#F5EDE4'
            }} data-id="element-357">
                LA CREADORA
              </span>
              <h2 className="text-2xl md:text-3xl font-bold mb-3" style={{
              color: '#ffffff'
            }} data-id="element-358">
                Creado por Emely
              </h2>
              <p className="text-base mb-3" style={{
              color: 'rgba(255,255,255,0.85)'
            }} data-id="element-359">
                Pastry Chef experta en estilo New York. Creadora del{' '}
                <span className="font-bold" style={{
                color: '#ffffff'
              }} data-id="element-360">
                  Método Cookie Master
                </span>
                , aplicado por miles de alumnas. Después de dominar volumen y
                arquitectura en cookies, aplicó esa misma ingeniería al clásico
                más amado.
              </p>
              <p className="text-lg font-bold italic" style={{
              color: '#ffffff',
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-361">
                "Lo XL no es tamaño. Es estructura."
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* REVIEWS CAROUSEL */}
      <section className="py-20 md:py-28 px-4 overflow-hidden" style={{
      backgroundColor: '#F5EDE4'
    }} data-id="element-362">
        <div className="max-w-6xl mx-auto" data-id="element-363">
          {/* Header */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.6
        }} className="text-center mb-12" data-id="element-364">
            <span className="text-sm font-bold tracking-[0.1em] uppercase mb-3 inline-block" style={{
            color: '#e76f51'
          }} data-id="element-365">
              MÁS DE +998 ALUMNAS FELICES
            </span>
            <h2 className="text-4xl md:text-5xl font-bold mb-4" style={{
            color: '#1A1614'
          }} data-id="element-366">
              Lo que dicen nuestras alumnas
            </h2>
            <p className="text-lg md:text-xl max-w-2xl mx-auto mb-6" style={{
            color: '#5a5248'
          }} data-id="element-367">
              Resultados reales de alumnas que empezaron desde cero. Cada review
              es una historia de alguien que decidió empezar.
            </p>
            <div className="flex flex-col items-center justify-center gap-2" data-id="element-368">
              <div className="flex items-center gap-1" data-id="element-369">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-6 h-6 fill-[#e76f51] text-[#e76f51]" data-id="element-370" />)}
              </div>
              <p className="text-base font-bold" style={{
              color: '#1A1614'
            }} data-id="element-371">
                +998 Reviews
              </p>
            </div>
          </motion.div>

          {/* Carousel Mobile (1 slide) */}
          <div className="block md:hidden relative w-full max-w-sm mx-auto" data-id="element-372">
            <AnimatePresence mode="wait" data-id="element-373">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              x: 50
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -50
            }} transition={{
              duration: 0.3
            }} className="bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden" data-id="element-374">
                <img src={newReviews[currentIndex].img} alt="Review photo" loading="lazy" decoding="async" className="w-full h-56 object-cover" data-id="element-375" />
                <div className="p-6" data-id="element-376">
                  <div className="flex items-center gap-1 mb-3" data-id="element-377">
                    {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-4 h-4 fill-[#e76f51] text-[#e76f51]" data-id="element-378" />)}
                  </div>
                  <h3 className="text-lg font-bold mb-2 uppercase tracking-wide" style={{
                  color: '#e76f51'
                }} data-id="element-379">
                    {newReviews[currentIndex].title}
                  </h3>
                  <p className="text-base mb-6" style={{
                  color: '#5a5248'
                }} data-id="element-380">
                    {newReviews[currentIndex].review}
                  </p>
                  <div className="flex items-center justify-between border-t border-gray-100 pt-4" data-id="element-381">
                    <p className="font-bold" style={{
                    color: '#1A1614'
                  }} data-id="element-382">
                      {newReviews[currentIndex].name}
                    </p>
                    <div className="flex items-center gap-1.5 bg-green-50 px-2 py-1 rounded-full" data-id="element-383">
                      <CheckCircleIcon className="w-4 h-4 text-green-600" data-id="element-384" />
                      <span className="text-xs font-bold text-green-700" data-id="element-385">
                        Alumna Verificada
                      </span>
                    </div>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Carousel Desktop (3 slides) */}
          <div className="hidden md:grid grid-cols-3 gap-6" data-id="element-386">
            <AnimatePresence mode="popLayout" data-id="element-387">
              {getVisibleSlides().map((review, i) => <motion.div key={`${currentIndex}-${i}`} initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0,
              scale: 0.95
            }} transition={{
              duration: 0.4
            }} className="bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden flex flex-col" data-id="element-388">
                  <img src={review.img} alt="Review photo" loading="lazy" decoding="async" className="w-full h-56 object-cover" data-id="element-389" />
                  <div className="p-6 flex-1 flex flex-col" data-id="element-390">
                    <div className="flex items-center gap-1 mb-3" data-id="element-391">
                      {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-4 h-4 fill-[#e76f51] text-[#e76f51]" data-id="element-392" />)}
                    </div>
                    <h3 className="text-lg font-bold mb-2 uppercase tracking-wide" style={{
                  color: '#e76f51'
                }} data-id="element-393">
                      {review.title}
                    </h3>
                    <p className="text-base mb-6 flex-1" style={{
                  color: '#5a5248'
                }} data-id="element-394">
                      {review.review}
                    </p>
                    <div className="flex items-center justify-between border-t border-gray-100 pt-4 mt-auto" data-id="element-395">
                      <p className="font-bold" style={{
                    color: '#1A1614'
                  }} data-id="element-396">
                        {review.name}
                      </p>
                      <div className="flex items-center gap-1.5 bg-green-50 px-2 py-1 rounded-full" data-id="element-397">
                        <CheckCircleIcon className="w-4 h-4 text-green-600" data-id="element-398" />
                        <span className="text-xs font-bold text-green-700" data-id="element-399">
                          Verificada
                        </span>
                      </div>
                    </div>
                  </div>
                </motion.div>)}
            </AnimatePresence>
          </div>

          {/* Dots Indicator */}
          <div className="flex justify-center gap-2 mt-10" data-id="element-400">
            {newReviews.map((_, i) => <button key={i} onClick={() => setCurrentIndex(i)} className={`w-3 h-3 rounded-full transition-all duration-300 ${i === currentIndex ? 'bg-[#e76f51] w-8' : 'bg-[#e76f51]/30'}`} aria-label={`Go to slide ${i + 1}`} data-id="element-401" />)}
          </div>
        </div>
      </section>
    </>;
}